import {
  GET_PROJECTS_BY_SCHEMAS,
  REMOVE_PROJECT,
  SET_NEW_PROJECT_INFO,
  GET_SCHEMA_TEMPLATE,
  NEW_PROJECT_OPENING,
  EMPTY_SCHEMA_TEMPLATE,
  SET_ERROR_OBJ,
  SET_ERROR
} from "./../actions/types";

const INITIAL_STATE = {
  projectsBySchemas: null,
  newProject: {
    name: '',
    assetSchemaId: '',
  },
  projectsErrors: [{}],
  newProjectSchema: null,
  newProjectCreating: false,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_PROJECTS_BY_SCHEMAS:
      const errors = action.payload.results.map(()=> {
        return {};
      });
      if(state.newProjectCreating){
        errors.push({})
      }
      return { ...state, projectsBySchemas: action.payload, projectsErrors:errors};
    case GET_SCHEMA_TEMPLATE:
      return { ...state, newProjectSchema: action.payload };
    case EMPTY_SCHEMA_TEMPLATE:
      return { ...state, newProjectSchema: null };
    case SET_NEW_PROJECT_INFO:
      return { ...state, newProject: action.payload };
    case NEW_PROJECT_OPENING:
      return {...state,newProjectCreating:action.payload};
    case SET_ERROR:
      let projectsErrors = state.projectsErrors;
      const {index,error,field} = action.payload;
      projectsErrors[index][field] = error;
      return {...state,projectsErrors};
    case SET_ERROR_OBJ:
      let arr = [];
      for(let i = 0;i < action.payload;i++){
        arr.push({});
      }

      return {...state,projectsErrors:arr};

    case REMOVE_PROJECT:
      const results = state.projectsBySchemas.results.filter((project,i) => {
        return i !== action.payload && project
      });
      return{ ...state, projectsBySchemas:{
        ...state.projectsBySchemas,
          results
        }};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/projects.js